


























































































































import { Component, Vue, Watch } from "vue-property-decorator";

import DataCemproService from "@/service/contabil/DataCemproService";
import { RelatorioDataCemproModel } from "@/models/contabil/data-cempro/RelatorioDataCemproModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioDataCempro extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  relatorio: RelatorioDataCemproModel = {
    inicio: undefined,
    fim: undefined
  };

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        DataCemproService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {

            if (res.data.byteLength > 0) {

              let fileURL = window.URL.createObjectURL(new Blob([res.data]));
              let fileLink = document.createElement("a");
              fileLink.href = fileURL;

              fileLink.setAttribute(
                "download",
                `relatorio_data_cempro.${
                  tipo.toLowerCase() === "excel" ? "xls" : "txt"
                }`
              );

              document.body.appendChild(fileLink);

              fileLink.click();
            } else {
              this.openDialog(true, "Alerta", "Não foi encontrado dados para geração");
            }

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        // this.limparformulario();
      }
    });
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
